import React, { useEffect, useState } from "react";
import config from "../../../setting";
import { formatDate, getTimeFromDate } from "../../../utils/DateUtils";


interface Position {
    lat: number;
    lng: number;
    provider: string;
    dateTime: Date[];
}

interface PositionElementProps {
    position: Position;
}

export const PositionElement: React.FC<PositionElementProps> = ({ position }) => {
    const [address, setAddress] = useState<{ place: string; address: string }>({ place: '--', address: '' });

    useEffect(() => {
        const H = (window as any).H;
        const platform = new H.service.Platform({
            apikey: config.HMap_AppKey
        });

        const searchService = platform.getSearchService();

        searchService.reverseGeocode({ at: `${position.lat},${position.lng}` }, (result: any) => {
            const place = result.items[0]
            if (place) {
                setAddress({
                    place: place.title,
                    address: place.title !== place.address.label ? place.address.label : ""
                });
            } else if (result.items.length > 0) {
                const item = result.items[0];
                setAddress({
                    place: item.title,
                    address: item.title !== item.address.label ? item.address.label : ""
                });
            }
        }, console.error);
    }, [position]);

    return (
        <div>
            <div className="min-h-[70px] p-4 flex flex-row justify-between min-w-[400px] ">
                <div className="flex-grow flex flex-col overflow-hidden justify-between">
                    <h1 className="text-[16px] leading-5 uppercase font-semibold mb-5">{address.place}</h1>
                    {/* <h2 className="text-lg">{address.address}</h2>*/}
                    <p
                        className={`font-normal w-[150px] text-[12px] leading-[14px] opacity-50 ${!address.address ? 'mt-[-10px]' : ''}`}
                    >
                        ({position.provider})
                    </p>
                </div>
                <div className="date-time-container max-h-[100px] w-full overflow-y-auto flex flex-col">
                    <div className="text-right flex flex-col overflow-visible ml-16">
                        {position.dateTime.map((date, index) => (
                            <div key={index} className="overflow-visible text-center flex-grow-0">
                                <h1 className="text-base uppercase font-bold">{formatDate(date)}</h1>
                                <h3 className="text-xl uppercase font-bold">{getTimeFromDate(date)}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="lat-lon ml-4">
                <div className="flex">
                    <div className="flex justify-center items-start">
                        <p className="uppercase text-[#919599] mr-1">Lat:</p>
                        <p>{Number(position?.lat?.toFixed(5))}</p>
                    </div>
                    <div className="flex justify-center items-start ml-2">
                        <p className="uppercase text-[#919599] mr-1">Lon:</p>
                        <p>{Number(position?.lng?.toFixed(5))}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
